import { UPDATE } from 'react-admin';

export const SALE_ITEM_UNDONE = 'SALE_ITEM_UNDONE';
export const itemUndone = (id, data) => ({
  type: SALE_ITEM_UNDONE,
  payload: { id, data: { ...data, doneAt: null, doneBy: null } },
  meta: { fetch: UPDATE, resource: 'saleItems' },
});